// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--R2bpz","footer__logo":"footer-module--footer__logo--11Tx-"};